// extracted by mini-css-extract-plugin
export default {"container":"shapes_container__nKt+k"};